import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/partner-place-applications`;

export const submitPartnerPlaceApplication = async (applicationData) => {
    const response = await axios.post(API_BASE_URL, applicationData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};